import {
  PracticeSetupStepCategory,
  PracticeSetupStepId,
} from '@principle-theorem/principle-core/interfaces';
import { map, switchMap } from 'rxjs/operators';
import { Staffer } from '../../staffer/staffer';
import {
  IPageVisitTrackingConfig,
  IPracticeSetupStepDefinition,
} from './practice-setup-step.types';
import { initRawSchema } from '@principle-theorem/editor';

const pageVisitTracking: IPageVisitTrackingConfig = {
  routes: ['settings/brand/{brandId}/teams'],
  validationMode: 'any',
};

export const teamsSetupStep: IPracticeSetupStepDefinition = {
  id: PracticeSetupStepId.TeamsSetup,
  category: PracticeSetupStepCategory.GeneralPracticeSettings,
  title: 'Organise Your Staff into Teams',
  description: initRawSchema(
    `Review default teams, add any additional, and organise your staff. Organising your staff into teams allows tasks to be allocated to groups of people rather than just individuals. Start by creating any Teams you may need and then allocate each staff member to their appropriate Team.`
  ),
  dependsOn: [PracticeSetupStepId.StaffSetup],
  getRoute: (brand, _practice) => `settings/brand/${brand.ref.id}/teams`,
  validate$: (practice$, _step, _options) => {
    return practice$.pipe(
      switchMap((practice) =>
        Staffer.byPractice$(practice).pipe(
          map((staff) => {
            const unassigned = staff.filter(
              (staffer) => !staffer.teams?.length
            );

            if (unassigned.length === 0) {
              return { valid: true };
            }

            const names = unassigned
              .map((staffer) => staffer.user.name)
              .join(', ');
            return {
              valid: false,
              reason: `The following staff are not assigned to a team: ${names}`,
              progress: {
                current: staff.length - unassigned.length,
                total: staff.length,
              },
            };
          })
        )
      )
    );
  },
  pageVisitTracking,
};
